// Third Party
import nookies from 'nookies';

import {
  NextApiRequest,
  NextApiResponse,
  GetServerSidePropsContext,
} from 'next';

// Utils
import { isProd } from './predicates';

const cookieKey = '__savvy_search__';

type NextApiContext = {
  req: NextApiRequest;
  res: NextApiResponse;
};

type IsomorphicContext = GetServerSidePropsContext | NextApiContext | undefined;

export function getSearchSession(ctx: IsomorphicContext): object | null {
  const cookies = nookies.get(ctx);

  const serializedData = cookies[cookieKey];

  if (serializedData) {
    try {
      return JSON.parse(serializedData);
    } catch (e) {
      console.error('Failed to deserialize session data:', e);
      return null;
    }
  } else {
    return null;
  }
}

export function setSearchSession(
  ctx: IsomorphicContext,
  sessionData: object | null
): void {
  if (sessionData) {
    const serializedData = JSON.stringify(sessionData);
    nookies.set(ctx, cookieKey, serializedData, {
      sameSite: 'lax',
      path: '/',
      secure: isProd,
    });
  } else {
    nookies.destroy(ctx, cookieKey, { path: '/' });
  }
}
